import { Clock } from "lucide-react";
import { formatRupiah } from "@/lib/billing";

const OVERDUE = [
  { key: "1_30", label: "1 – 30 hari", color: "#3B82F6" },
  { key: "31_60", label: "31 – 60 hari", color: "#FBBF24" },
  { key: "61_90", label: "61 – 90 hari", color: "#F97316" },
  { key: "gt_90", label: "> 90 hari", color: "#EF4444" },
];

// Baris klik → daftar Invoice kategori ini; nominal Rp0 tidak dapat diklik.
function AgingBar({ label, color, value, max, k, onOpen, compact, short }) {
  const w = max > 0 ? Math.max(value > 0 ? 3 : 0, (value / max) * 100) : 0;
  const clickable = !!onOpen && value > 0;
  return (
    <button type="button" disabled={!clickable} onClick={() => onOpen(k)}
         title={clickable ? `Lihat invoice tunggakan ${label}` : "Tidak ada tunggakan"}
         className="w-full text-left grid grid-cols-[76px_1fr_112px] sm:grid-cols-[96px_1fr_120px] items-center gap-2 sm:gap-3 rounded-md px-1 -mx-1 py-0.5 transition-colors enabled:cursor-pointer enabled:hover:bg-[#F9FAFB] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#1D4ED8] disabled:cursor-default group"
         data-testid={`aging-row-${k}`}>
      <span className="text-xs sm:text-sm text-[#374151] whitespace-nowrap">{label}</span>
      <div className={`${compact ? "h-4 sm:h-5" : "h-5 sm:h-6"} rounded bg-[#F3F4F6] overflow-hidden`}>
        <div className="h-full rounded transition-[width] duration-500" style={{ width: `${w}%`, background: color }} />
      </div>
      <span className="text-right font-mono text-xs sm:text-sm text-[#111827] whitespace-nowrap"
            data-testid={`aging-${k}-nominal`}>
        {formatRupiah(value)}
        {clickable && <span className={`${short ? "ml-1 text-[#1D4ED8]" : "block"} text-[9px] font-sans font-semibold text-[#1D4ED8] opacity-70 group-hover:opacity-100`}>{short ? "→" : "Lihat invoice →"}</span>}
      </span>
    </button>
  );
}

export const AgingChart = ({ data, loading, onOpen, compact = false, short = false }) => {
  const byKey = Object.fromEntries((data?.buckets || []).map((b) => [b.key, b]));
  const vals = OVERDUE.map((o) => byKey[o.key]?.total_sisa || 0);
  const max = Math.max(0, ...vals);
  return (
    <div className={`rounded-lg border bg-white p-3 ${compact ? "" : "sm:p-4"} h-full flex flex-col`} data-testid="dashboard-aging">
      <div className={`flex items-center justify-between gap-2 ${compact ? "mb-1.5" : "mb-3"} flex-wrap`}>
        <h3 className="font-black text-sm sm:text-base text-[#111827] flex items-center gap-2">
          <Clock className="w-4 h-4" /> Tunggakan (Aging)
        </h3>
        <span className="text-[10px] text-[#6B7280]" data-testid="aging-as-of">
          Posisi per {data?.as_of || "—"} (WIB)
        </span>
      </div>
      {loading && !data ? (
        <div className="text-xs text-[#6B7280] py-10 text-center flex-1">Memuat…</div>
      ) : (
        <div className={`flex-1 flex flex-col justify-between ${compact ? "gap-2" : "gap-4"}`}>
          <div className={compact ? "space-y-1" : "space-y-3"}>
            {OVERDUE.map((o, i) => (
              <AgingBar key={o.key} k={o.key} label={o.label} color={o.color} value={vals[i]} max={max} onOpen={onOpen} compact={compact} short={short} />
            ))}
          </div>
          <button type="button" disabled={!onOpen || !(data?.total_tunggakan > 0)} onClick={() => onOpen("overdue")}
               title={data?.total_tunggakan > 0 ? "Lihat seluruh invoice tunggakan" : "Tidak ada tunggakan"}
               className={`w-full text-left flex items-center justify-between gap-2 rounded-md bg-[#FEF2F2] border border-[#FEE2E2] px-3 ${compact ? "py-1.5" : "py-2.5"} transition-[box-shadow] enabled:cursor-pointer enabled:hover:shadow-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-[#B91C1C] disabled:cursor-default`}
               data-testid="aging-total-tunggakan">
            <span className="text-xs sm:text-sm font-semibold text-[#991B1B]">Total Tunggakan</span>
            <span className="font-mono font-black text-base sm:text-lg text-[#B91C1C]" data-testid="aging-total-tunggakan-nominal">
              {formatRupiah(data?.total_tunggakan || 0)}
              {data?.total_tunggakan > 0 && onOpen && <span className={`${short ? "ml-1 text-xs" : "block text-right text-[9px]"} font-sans font-semibold text-[#B91C1C] opacity-80`}>{short ? "→" : "Lihat invoice →"}</span>}
            </span>
          </button>
        </div>
      )}
      <div className={`text-[10px] text-[#6B7280] ${compact ? "mt-1" : "mt-2"} leading-snug`}>
        Sisa invoice aktif yang sudah lewat jatuh tempo; bon carry-forward memakai jatuh tempo asal (paling awal di rantainya). Tidak mengikuti filter periode.
      </div>
    </div>
  );
};
